import defaultAxios, { AxiosResponse } from "axios";
import { useState, useEffect } from "react";

export const UseAxios = (opts: any, axiosInstance = defaultAxios) => {


    const [state, setState] = useState<{
        loading: boolean;
        error: any; // Adjust the type as needed for error handling.
        data: AxiosResponse<any, any> | null;
    }>({
        loading: true,
        error: null,
        data: null
    });
    const [trigger, setTrigger] = useState(0);


    const refetch = () => {
        setState({
            ...state,
            loading: true
        });
        setTrigger(Date.now());
    };

    useEffect(() => {
        if (opts.url == null) return;
        axiosInstance(opts)
            .then((data) => {
                setState({
                    ...state,
                    loading: false,
                    data
                });
            })
            .catch((error) => {
                setState({ ...state, loading: false, error });
            });
    }, [trigger]);
    return { ...state, refetch };
};